//region :: Imports ::
import {MNullable} from '../Utils';
import IMAccessTokenProvider from './IAccessTokenProvider';

//endregion

/** */
class MNSwagClientConfiguration {

    private readonly m_apiKey: string;
    private readonly m_accessTokenProvider: MNullable<IMAccessTokenProvider>;

    /** */
    public constructor(apiKey: string, accessTokenProvider: MNullable<IMAccessTokenProvider>) {

        this.m_apiKey = apiKey;
        this.m_accessTokenProvider = accessTokenProvider;

    }

    /** */
    public get apiKey(): string {
        return this.m_apiKey;
    }

    /** */
    public get requiresAuthentication(): boolean {
        return this.m_accessTokenProvider !== null;
    }

    /** */
    public get accessTokenProvider(): MNullable<IMAccessTokenProvider> {
        return this.m_accessTokenProvider;
    }

}

export default MNSwagClientConfiguration;
